import script from "./PageCaption.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageCaption.vue?vue&type=script&setup=true&lang=ts"

import "./PageCaption.vue?vue&type=style&index=0&id=9461f90e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9461f90e"]])

export default __exports__